"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _reactI18next = require("react-i18next");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _Switch = require("../../../ui/Switch");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var DirectFlightControl = function DirectFlightControl() {
  var _useTranslation = (0, _reactI18next.useTranslation)('SEARCH_FORM'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: _fn.QUERY_PARAMS.IS_DIRECT_FLIGHT,
    render: function render(_ref) {
      var field = _ref.field,
        form = _ref.form;
      return /*#__PURE__*/_react.default.createElement(_Switch.Switch, {
        checked: field.value,
        className: _styles.default.switch,
        label: t('IS_DIRECT_FLIGHT_CONTROL_LABEL'),
        onChange: function onChange(checked) {
          form.setFieldValue(field.name, checked);
        }
      });
    }
  });
};
var _default = exports.default = DirectFlightControl;